import { render, staticRenderFns } from "./TijanasReport.vue?vue&type=template&id=2335cf67&"
import script from "./TijanasReport.vue?vue&type=script&lang=js&"
export * from "./TijanasReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports